var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { "no-margin": "", "no-padding": "", xs: "12" } },
    [
      _vm._l(_vm.conditions, function (condition, i) {
        return _c(
          "w-transition-slide-height",
          { key: condition.key },
          [
            _vm.shouldShowKey(condition.key)
              ? _c("app-field-condition-edit", {
                  attrs: {
                    value: condition,
                    "is-first": i == 0,
                    fields: _vm.fields,
                    "model-name": "Sale",
                  },
                  on: {
                    remove: function ($event) {
                      return _vm.removeCondition(i)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        )
      }),
      _c(
        "w-row",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { flat: "", icon: "plus" },
              on: {
                click: function ($event) {
                  return _vm.addCondition()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("add-condition")))]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }